import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';
import { log, sendMail, getEmailsParticipantsInBill } from '../../utils/functions';

function CreateBillComm({ bill, onLoadBillComm, onClose, userNotify: { mailAppr, mailCoun } }) {

	const [comm, setComm] = useState('');
	const [emails, setEmails] = useState('');
	const [loadbtn, setLoadbtn] = useState(false);
	const [errors, setErrors] = useState({ comm: false });
	const [data, setData] = useState([]);
	const { iden, mail, name, sapDB } = useSelector((state) => state.user);

	const buildUniqueEmails = (...values) => {
		const parsed = values
			.filter(Boolean)
			.flatMap((entry) => String(entry).split(','))
			.map((entry) => entry.trim())
			.filter(Boolean);

		return [...new Set(parsed)].join(', ');
	};

	const handleCreateComm = async () => {
		setLoadbtn(true);
		const newErrors = {};
		if (comm === '') newErrors.comm = true;

		setErrors(newErrors);

		if (Object.values(newErrors).some(error => error)) {
			setLoadbtn(false);
			return;
		}

		try {
			const response = await fetch(apiurl + 'tableINSE', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					table: 'bil__post',
					fiels: `note, bill, publ, auth, mess, iden_form`,
					vals: `0,'${bill.docu}',now(),'${iden}','${comm}', ${bill.iden_form}`,
					exist: `1=0`
				}),
			});

			if (response.ok) {
				const responseData = await response.json();
				setData(responseData);

				if (responseData[0].error !== 1) {

					log('mod', 'bill', bill.docu, mail, iden, `add note ${bill.docu}`);


					let body = `${name} dijo: <br><br>${comm}<br><br>Puede ver la factura <a href='${window.location.origin}?db=${sapDB}&bill=${bill.iden_form}'>aquí</a>`;
					if (emails) await sendMail(emails, `Se ha agregado un mensaje a la factura N°${bill.FolioNum} de ${bill.CardName} (RUT ${bill.CardCode})`, body);

					onClose();
					onLoadBillComm();
				} else {
					console.log(responseData[0].msg);
					setLoadbtn(false);
				}
			} else {
				setLoadbtn(false);
				throw new Error('Error en la solicitud POST');
			}
		} catch (error) {
			setLoadbtn(false);
			console.error('Error al crear Nota:', error);
		}
	}

	useEffect(() => {
		const loadParticipants = async () => {
			try {
				const { emails: mailFromPosts } = await getEmailsParticipantsInBill(mail, bill.iden_form);
				const allEmails = buildUniqueEmails(mailFromPosts, mailAppr, mailCoun, bill?.mail_approver, bill?.cc_mail_user);
				setEmails(allEmails);
			} catch (error) {
				const fallbackEmails = buildUniqueEmails(mailAppr, mailCoun, bill?.mail_approver, bill?.cc_mail_user);
				setEmails(fallbackEmails);
			}
		};

		loadParticipants();
	}, [bill, mail, mailAppr, mailCoun]);

	return (
		<form>
			<orm-modal>
				<dialog open>
					<h2>Agregando mensaje</h2>
					<fieldset>
						<textarea value={comm} onChange={(e) => setComm(e.target.value)} className={errors.comm || data[0]?.comm === 1 ? 'error' : ''}></textarea>
					</fieldset>
					<table>
						<tfoot>
							<tr>
								<td></td>
								<td>
									<input type="button" value="Cancelar" onClick={onClose} />
									<input type="button" value="Agregar" onClick={handleCreateComm} disabled={loadbtn} />
								</td>
							</tr>
						</tfoot>
					</table>
				</dialog>
			</orm-modal>
		</form>
	);

}

export default CreateBillComm;